import React from "react";
import ScrollToTop from "../components/effects/ScrollToTop";
import SectionHeader from "../components/sections/Header";
import SectionsFooter from "../components/sections/Footer";
import CanvasOffre from "../components/effects/CanvasOffre";
import CanvasContact from "../components/effects/CanvasContact";
import { ButtonQuiz } from "../components/effects/ButtonQuiz";
// import { StickyPack } from "../components/effects/StickyPack";

export default function BaseLayout({ children }) {
  return (
    <>
      {/* <StickyPack /> */}
      <ScrollToTop />
      <ButtonQuiz />
      <CanvasOffre />
      <CanvasContact />
      <SectionHeader />
      <main>
        <a href="/identity.json" className="visually-hidden">
          Fiche d'identité structurée — identity.json
        </a>
        <div id="image-fond"></div>
        <div className="container-fluid position-relative">{children}</div>
      </main>
      <SectionsFooter />
    </>
  );
}
